import { Button, Paragraph, YStack } from 'tamagui';

const TAP_TARGET_MIN = 44;

/** The three example prompts offered on an empty thread. */
const EXAMPLE_PROMPTS = [
  'What does a P0300 code mean for my car?',
  'Is my mileage due for any service?',
  'What are common problems for this model?',
] as const;

/** Intro + tappable example prompts; tapping fills the composer (does not send). */
export function ChatEmptyState({ onPick }: { onPick: (text: string) => void }) {
  return (
    <YStack gap="$3" paddingVertical="$4" flex={1}>
      <Paragraph color="$color10">
        Ask anything about this vehicle — diagnostics, service timing, or common issues. Try one
        of these to get started:
      </Paragraph>
      <YStack gap="$2">
        {EXAMPLE_PROMPTS.map((prompt) => (
          <Button
            key={prompt}
            minHeight={TAP_TARGET_MIN}
            height="auto"
            paddingVertical="$2"
            justifyContent="flex-start"
            onPress={() => onPick(prompt)}
          >
            {prompt}
          </Button>
        ))}
      </YStack>
    </YStack>
  );
}
